import {
  background,
  type BackgroundProps,
  border,
  type BorderProps,
  color,
  type ColorProps,
  compose,
  flexbox,
  type FlexboxProps,
  grid,
  type GridProps,
  layout,
  type LayoutProps,
  position,
  type PositionProps,
  shadow,
  type ShadowProps,
  space,
  type SpaceProps,
  typography,
  type TypographyProps,
} from 'styled-system';

import { createShouldForwardProp, props } from '@styled-system/should-forward-prop';

export function sfp(p: string[] = []) {
  return createShouldForwardProp([...props, ...p]);
}

export const shouldForwardProp = createShouldForwardProp(props);

export type AllSystemProps = LayoutProps &
  FlexboxProps &
  PositionProps &
  GridProps &
  SpaceProps &
  BackgroundProps &
  ColorProps &
  BorderProps &
  ShadowProps &
  TypographyProps;

export const allSystemProps = compose(layout, flexbox, position, grid, space, background, color, border, shadow, typography);

export type CommonSystemProps = LayoutProps & PositionProps & FlexboxProps & GridProps & SpaceProps & BorderProps;

export const commonProps = compose(layout, position, flexbox, grid, space, border);
